export type ExtractFilterScale = 'dow' | 'month';

export const EXTRACT_VALUES: Record<ExtractFilterScale, number[]> = {
    dow: [0, 1, 2, 3, 4, 5, 6],
    month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
};
export const DEFAULT_SCALE = 'month';
export const DEFAULT_VALUE = '';
